import { Text, Icons, styled } from '@/theme/index';

const Wrapper = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  marginTop: theme.spacing(2.5),
}));

const FlexHeader = styled(Text)`
  display: flex;
  align-items: flex-end;
`;

export function DarkWebNoBreachesFound() {
  return (
    <Wrapper>
      <FlexHeader variant="h3" mb="12" fontWeight="bold">
        <Icons.Check color="success" fontSize="medium" /> No Breaches Found
      </FlexHeader>
      <Text variant="body1">
        Please be advised that no results does not guarantee that your
        information has never been compromised.
      </Text>
      <Text variant="body1">
        Be sure to check for Dark Web Scan notifications to stay up-to-date on
        the safety of your email.{' '}
      </Text>
    </Wrapper>
  );
}
